
export const types = <const>{
	mutations: {
		VOZIDLO_ZAKAZNIK_FILTER_SELECT_MAPPER: 'VOZIDLO_ZAKAZNIK_FILTER_SELECT_MAPPER',
		VOZIDLO_LEASING_ZAKAZNIK_FILTER_SELECT_MAPPER: 'VOZIDLO_LEASING_ZAKAZNIK_FILTER_SELECT_MAPPER',
		VOZIDLO_POJISTOVNA_FILTER_SELECT_MAPPER: 'VOZIDLO_POJISTOVNA_FILTER_SELECT_MAPPER',
	},

};
